import React from "react";
import { Button } from "reactstrap";
import { buildPlanLineItems, splitPriceDisplay, truncatePlanDescription } from "./planUtils";
import "./subscriptionPlanCard.css";

const SubscriptionPlanCard = ({
  name,
  priceDisplay,
  description = "",
  features = [],
  entitlements = [],
  isCurrent = false,
  ctaLabel = "Subscribe",
  ctaDisabled = false,
  ctaLocked = false,
  onCtaClick,
  emptyMessage,
}) => {
  const { amount, interval } = splitPriceDisplay(priceDisplay);
  const lineItems = buildPlanLineItems(features, entitlements);
  const fullDescription = String(description || "").trim();
  const displayDescription = truncatePlanDescription(fullDescription);
  const showDescriptionTooltip = fullDescription && fullDescription !== displayDescription;

  return (
    <div className={`stripe-plan-card ${isCurrent ? "is-current" : ""}`}>
      {isCurrent && (
        <span className="stripe-plan-card-ribbon" aria-hidden="true">
          Current
        </span>
      )}

      <div className="stripe-plan-card-header">
        <h3 className="stripe-plan-card-name">{name}</h3>
        <div className="stripe-plan-card-price">
          <span className="stripe-plan-card-price-amount">{amount}</span>
          {interval && (
            <span className="stripe-plan-card-price-interval">{interval}</span>
          )}
        </div>
        <p
          className="stripe-plan-card-description"
          title={showDescriptionTooltip ? fullDescription : undefined}
        >
          {displayDescription || "\u00a0"}
        </p>
      </div>

      <ul className="stripe-plan-card-features">
        {lineItems.map((item, idx) => (
          <li key={`plan-line-${idx}`} className="stripe-plan-card-feature">
            <span className="stripe-plan-card-feature-text">{item}</span>
            <i className="fas fa-check stripe-plan-card-feature-icon" aria-hidden="true" />
          </li>
        ))}
        {lineItems.length === 0 && emptyMessage && (
          <li className="stripe-plan-card-feature stripe-plan-card-feature--empty">
            <span className="stripe-plan-card-feature-text">{emptyMessage}</span>
          </li>
        )}
      </ul>

      <Button
        className={`stripe-plan-card-cta ${isCurrent ? "is-current-cta" : ""} ${ctaLocked ? "is-locked-cta" : ""}`}
        color="primary"
        disabled={ctaDisabled}
        onClick={onCtaClick}
      >
        {ctaLabel}
      </Button>
    </div>
  );
};

export default SubscriptionPlanCard;
